import { createFileRoute } from "@tanstack/react-router";
import { seo, breadcrumbScript } from "@/lib/seo";
import { LegalCard, LegalPage } from "@/components/app/legal-page";

const TITLE = "About The Quantum Minds";
const DESC =
  "The Quantum Minds is an all-in-one productivity platform for JEE aspirants — revision planning, question tracking, tests and study tools.";

export const Route = createFileRoute("/about")({
  head: () => ({
    ...seo({
      title: "About The Quantum Minds — Study Platform for JEE",
      description: DESC,
      path: "/about",
    }),
    scripts: [
      breadcrumbScript([
        { name: "Home", path: "/" },
        { name: "About", path: "/about" },
      ]),
    ],
  }),
  component: AboutPage,
});

function AboutPage() {
  return (
    <LegalPage title={TITLE}>
      <section className="glass rounded-3xl p-5">
        <p className="text-sm leading-relaxed text-muted-foreground">
          The Quantum Minds is an all-in-one productivity platform designed for JEE aspirants. It
          helps students plan revisions, track question practice, manage tests, analyze progress and
          access educational tools in one place.
        </p>
        <p className="mt-3 text-sm leading-relaxed text-muted-foreground">
          The Quantum Minds is independently operated by Aryan Singh.
        </p>
      </section>
      <LegalCard
        heading="Our mission"
        points={[
          "Help students study consistently through smart planning.",
          "Improve preparation with organized, structured learning.",
          "Keep every study tool a student needs in a single place.",
        ]}
      />
    </LegalPage>
  );
}